import { Trans } from "@web-monorepo/i18n/macro";
import { DDSButton } from "@web-monorepo/dds";
import styles from "./ShufflingAvatars.module.css";

type ShufflingAvatarsProps = {
  avatar?: string;
};

export default function ShufflingAvatars({ avatar }: ShufflingAvatarsProps) {
  return (
    <div className={styles.container}>
      <div className={styles.avatarWrap}>
        <img src={avatar} className={styles.avatar} alt="" />
      </div>
      <DDSButton data-name="shuffling_avatars:toolkit.table_topics.shuffling" variant="secondary" disabled>
        <Trans>Shuffling...</Trans>
      </DDSButton>
    </div>
  );
}
